import { InvoiceTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1820. 請求タスク編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  name: string;
  description?: string;
  billing_schedule_detail_id: number;
  due_date?: string;
  user_id: number;
};

const updateInvoiceTask = (props: Props): Promise<InvoiceTask> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.id}`, props);
};

export const useUpdateInvoiceTask = () => {
  return useMutation({
    mutationFn: updateInvoiceTask,
  });
};
